import { TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import React, { useEffect } from 'react';

interface SwitchProps {
    options: any,
    name: string,
    onChange?: any,
    onBlur?: any,
    size?: "small" | "medium" | 'large',
    value?: any,
    errors?: any,
    helperText?: any,
    getOptionLabel?: any,
    placeholder?: any,
    disabled:boolean
}

export const CMAutoComplete = (props: SwitchProps) => {
    const changeField = (e: any, newValue: any) => {
        props.onChange(newValue);
        setValue(newValue);
    }
    const [value, setValue] = React.useState<any>('')
    useEffect(() => {
        setTimeout(() => {
            if (props.value && value === '')
                setValue(props.value)
        }, 100)
    }, [props])
    return (
        <Autocomplete
            fullWidth={true}
            clearOnEscape={true}
            disabled={props.disabled}
            size='small'
            options={props.options}
            isOptionEqualToValue={(option, value) => value && option.id === value.id}
            value={value}
            onChange={changeField}
            renderInput={(params: any) => <TextField {...params} name={props.name} error={props.errors} helperText={props.helperText} />}
        />
    )
}

